import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { Button } from "react-bootstrap";

const ExternalUserList = ({
  match,
  getExternalUsersList,
  getExternalUserData=[]
}) => {
  const headers = [
    "Contract No.",
    "Lead Id",
    "Project Id",
    "External User Email",
    "External User Name",
    "External User Mobile Number"
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();

//   const headerBtns = () => {
//     return (
//       <Fragment>
//         <Button
//           onClick={filterToggle}
//           className="filter-hamburger btn btn-transparent"
//         >
//           <img src={Images?.Filter} alt=""></img>
//           {localization.showFilters}
//         </Button>
//       </Fragment>
//     );
//   };

  useEffect(() => {
    (async () => {
        setIsLoading(true)
        await getExternalUsersList(match?.params?.lead_id)
        setIsLoading(false)
    })();
}, [])

//   const filterToggle = () => {
//     setShowFilter(!showFilter);
//   };

const onPageChange = async (val) => {
    setIsLoading(true);
    await getExternalUsersList(null, val.selected + 1);
    setIsLoading(false);
};


// const applyFilter = async (filterData) => {
//     localStorage.setItem("all_valet_list_filter", JSON.stringify(filterData));
//     setListData([])
//     setIsLoading(true);
//     setFilterData(filterData);
//     console.log("Filter Data: " + JSON.stringify(filterData));
//     await getExternalUsersList(filterData, 1);
//     setIsLoading(false);
//     filterToggle();
// };



useEffect(() => {
    const tableData = [
      "contract_id",
      "lead_id",
      "project_id",
      "external_user_name",
      "external_user_email",
      "mobile_number"
    ];
  
    if (getExternalUserData && getExternalUserData.data) {
      const data = getExternalUserData.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: element[key] || '', 
          }))
        )
      );
  
      setListData(data.length > 0 ? data : []);
      setPageCount(
        Math.ceil(getExternalUserData.total / getExternalUserData.per_page)
      );
    }
  }, [getExternalUserData]);
  


  return (
    <Layout
      title={'External User Mapping'}
    //   Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={getExternalUserData?.from}
        onPageChange={onPageChange}
      />
{/* 
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        allValetListFilter
      /> */}
    </Layout>
  );
};

export default ExternalUserList;
